import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { apiClient } from '../../../apiClient'
import { CreateItem, Pagination, Product, Response } from './types'

class ProductApi {
  private api: AxiosInstance

  constructor(config: AxiosRequestConfig) {
    this.api = apiClient.create(config)
  }

  createItem = (payload: CreateItem, country_code: string) => {
    const headers: Record<string, string> = {
      ...(country_code && { 'x-afb-country-code': country_code }),
    }
    return this.api.post<Response<any>>(
      `/gw1/puja/internal/v1/products/create-product`,
      payload,
      { headers },
    )
  }

  updateItem = (payload: CreateItem, product_id: string, country_code: string) => {
    const headers: Record<string, string> = {
      ...(country_code && { 'x-afb-country-code': country_code }),
    }
    return this.api.put<Response<any>>(
      `/gw1/puja/internal/v1/products/${product_id}/update-product`,
      payload,
      { headers },
    )
  }

  getProductList = (paginationProps: Pagination, country_code?: string, search?: string, filterType?: string) => {
    const headers: Record<string, string> = {
      ...(country_code && { 'x-afb-country-code': country_code }),
    }
    return this.api.get<Response<Product[]>>(
      `/gw1/puja/internal/v1/products/product-list`,
      {
        params: {
          ...paginationProps,
          ...(search && { search }),
          ...(filterType && { filter_type: filterType }),
        },
        ...(headers && { headers }),
      },
    )
  }
}

export default ProductApi
